import {
  Box,
  Divider,
  Typography,
} from "@mui/material";
import React, { useContext, } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Logo from "src/components/Logo";
import GoogleLogin from "./google";
import LinkedLogin from "./linkedin";

import SideBg from "../SideBg";
import { useTranslation } from "react-i18next";
import { Users } from "src/context";
import Page from "src/components/Page";
import DefaultLoginForm from "./forms/default";
import MagicLinkLogin from "./forms/magiclink";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const Login = () => {

  const searchParams = useQuery();
  const form = searchParams.get("form");

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mixpanel } = useContext(Users);
  const [formtype, setFormtype] = React.useState(form || "default"); // default or magic-link

  React.useEffect(() => {
    mixpanel.track("Login Page", {
      location: window.location.href,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Login">
      <Box
        sx={(themes) => ({
          height: "80px",
          alignItems: "center",
          [themes.breakpoints.up("md")]: {
            alignItems: "center",
            boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.04)",
            pl: "99px",
            display: "none",
          },
          [themes.breakpoints.down("md")]: {
            justifyContent: "flex-start",
            pl: "24px !important",

            display: "flex",
          },
        })}
      >
        <Logo />
      </Box>

      <Box
        sx={{
          minHeight: { xs: "calc(100vh - 120px)", md: "calc(100vh - 0px)" },
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Box
          sx={{
            pt: {
              md: "120px",
            },
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "440px" },
            }}
          >
            <Box>
              <Box mb={"4px"}>
                <Typography
                  sx={{
                    fontSize: "26px",
                    lineHeight: "normal",
                    textAlign: "center",
                    letterSpacing: "-0.01em",
                    fontFamily: "var(--font-grenettepromedium)",
                  }}
                >
                  {t("login.welcome")}
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "24px",
                  textAlign: "center",
                }}
              >
                {t("login.description.first")}
              </Typography>

              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "var(--color-gray-700)",
                }}
              >
                {t("login.description.second")}
              </Typography>
            </Box>

            {/* button */}
            <Box
              sx={{
                mt: "33px",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                gap: "20px",
              }}
            >
              <GoogleLogin />

              <LinkedLogin />
            </Box>

            {/* divider */}
            <Box
              sx={{
                width: "100%",
                mt: "34px",
                textAlign: "center",
                alignContent: "center",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <Box
                sx={{
                  margin: "auto",
                }}
              >
                <Box>
                  <Divider>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "24px",
                        textAlign: "center",
                        color: "var(--color-gray-700)",
                        fontFamily: "var(--font-work-sans)",
                      }}
                    >
                      {t("login.description.third")}
                    </Typography>
                  </Divider>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                width: "100%",
                mt: "20px",
              }}
            >
              <Box
                sx={{
                  maxWidth: "460px",
                  m: "auto",
                  px: { xs: "20px", md: "0px" },
                }}
              >
                {/* default login form */}
                {formtype === "default" && <DefaultLoginForm setFormtype={setFormtype} />}

                {/* magic link login form */}
                {formtype === "magic-link" && <MagicLinkLogin setFormtype={setFormtype} />}
              </Box>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "24px",
                  textAlign: "center",
                  color: "#000",
                }}
              >
                Are you a client?
                <Typography
                  variant="subtitle"
                  sx={{
                    cursor: "pointer",
                    marginLeft: 0.5,
                    marginRight: 0.5,
                    color: "var(--color-brand-primary)",
                    fontFamily: "var(--font-grenettepro)",
                  }}
                  onClick={() => navigate("/login/client-portal")}
                >
                  Click here to sign in.
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            overflow: "hidden",
            width: "1100px",
            display: { xs: "none", lg: "block" },
          }}
        >
          <SideBg />
        </Box>
      </Box>
    </Page>
  );
};

export default Login;
